import { Record, OrderedMap } from 'immutable';
import create from './create';

const OnlineHomeworkContentItemRecord = Record({
  name: undefined,
  description: undefined,
});

const OnlineHomeworkContentRecord = Record({
  unitId: undefined,
  unitOrderingSequence: undefined,
  lessonNumber: undefined,
  contentItems: new OrderedMap(),
});

class OnlineHomeworkContentItem extends OnlineHomeworkContentItemRecord { }
class OnlineHomeworkContent extends OnlineHomeworkContentRecord { }

OnlineHomeworkContent.Item = OnlineHomeworkContentItem;
OnlineHomeworkContent.create = create;

export default OnlineHomeworkContent;



// WEBPACK FOOTER //
// ./data/OnlineHomework/Content/model.js